import instanciaAxios from './InterceptorAxios';

const servicioPlazacobro = {
	guardar(plaza) {
		return instanciaAxios.post('/plazacobro/guardar.json',plaza);
  },
  eliminar(plaza){
    return instanciaAxios.post('plazacobro/eliminar.json',plaza);
  },
  buscarPlaza(plaza){
    return instanciaAxios.post('plazacobro/buscarPlaza.json',plaza);
  },
  buscarPlazas(){
    return instanciaAxios.post('plazacobro/plazasCobro.json');
  }
}

export default servicioPlazacobro;